import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../icon";
export default function Home1(props) {
    return (_jsx(Icon, { ...props, children: _jsx("path", { d: "M21.707 1.293a1 1 0 0 0-1.414 0l-8.958 8.958a6.5 6.5 0 1 0 1.414 1.414l2.751-2.75 2.293 2.292a1 1 0 0 0 1.414 0l3.5-3.5a1 1 0 0 0 0-1.414L20.414 4l1.293-1.293a1 1 0 0 0 0-1.414ZM19 5.414 20.586 7 18.5 9.086 16.914 7.5 19 5.414ZM7.5 11c1.243 0 2.367.503 3.182 1.318A4.5 4.5 0 1 1 7.5 11Z" }) }));
}
